<template>
  <div>
    <h3 class="text-center mb-4 mt-4">下载历史</h3>
    <div class="page-title-desc text-center mb-4 mt-4">您在云联万维官网网站，下载镜像的历史信息</div>
    <page-body>
      <history-list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import HistoryList from './components/List'

export default {
  name: 'DownloadHistory',
  components: {
    HistoryList,
  },
  data () {
    return {
      listId: 'downloadHistoryList',
    }
  },
}
</script>
<style lang="scss" scoped>
  .page-title-desc {
    color: #5F6368;
    font-size: 16px;
  }
</style>
